/**
 * Created by ZhangJunPeng on 2017/5/22.
 */

import React from 'react';
import moment from 'moment';
import { ContextMenuTrigger } from 'react-contextmenu';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { ROLES_KEY, SYSTEM_SHOW_MEETING_PRIVATE } from '../../utils/constants';

class MeetingDiv extends React.Component {
  constructor(props) {
    super(props);
    const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
  }

  makeContent(flag, flag2, meeting, type, over) {
    if (!(flag || flag2)) {
      return meeting.name;
    } else {
      const endTime = moment(meeting.endTime);
      if (endTime.isBefore(moment())) {
        return meeting.name;
      } else {
        return meeting.name;
      }
    }
  }

  render() {
    const { meeting, roomId, meetingPolicy: {showMeetingPrivateInfo}, userInfo = {} } = this.props;
    const { userId, roleKey } = userInfo;
    const time = `${moment(meeting.startTime).format('HH:mm')}-${moment(
      meeting.endTime
    ).format('HH:mm')}`;
    // 当前登陆人是创建人或主持人
    const flag = meeting.creatorId === userId || meeting.holdId === userId;
    const over = meeting.status === 2 || meeting.status === 4;
    // 会议参会人存在当前登陆人
    let flag2 = false;
    if (meeting.hasOwnProperty('members')) {
      flag2 = (meeting.members + ';').indexOf(userId + ';') !== -1;
    }
    let meetingStatus =
      meeting.status == 4
        ? '(' + this.props.intl.formatMessage({ id: 'meeting_rejected' }) + ')'
        : meeting.status == 5
          ? '(' +
            this.props.intl.formatMessage({ id: 'meeting_no_approved' }) +
            ')'
          : '';
    const divClass = classNames({
      'my-meetings': flag,
      approval_meeting: flag2,
      available: true
    });
    /**
     * 获取会议标题
     *
     */
    const getMeetingTitle = (meeting, showMeetingPrivateInfo) => {
      const { roomAdmins = '' } = meeting;
      // 当前登陆人是创建人
      const isMyCreate = meeting.creatorId === userId || meeting.holdId === userId;
      // 当前登陆人是参会人
      const isMyMeeting = meeting.hasOwnProperty('members') ? (((meeting.members + ';').indexOf(userId + ';') === -1) ? false : true) : false;
      if (showMeetingPrivateInfo === SYSTEM_SHOW_MEETING_PRIVATE.yes) {
        // 允许公开会议主题和预订人信息
        return meeting.name + ', ' + meeting.holder;
      } else {
        // 不允许公开会议主题和预订人信息
        if (roleKey === ROLES_KEY.admin) {
          // 系统管理员
          return meeting.name + ', ' + meeting.holder;
        }
        if (roomAdmins && roleKey === ROLES_KEY.room_admin && roomAdmins.indexOf(userId) !== -1) {
          // 会议室管理员，可查询自己管理会议室下的所有会议
          return meeting.name + ', ' + meeting.holder;
        }
        // 普通用户, 只能看到参会人有自己的会议
        return (isMyCreate || isMyMeeting) ? meeting.name + ', ' + meeting.holder : '';
      }
    };
    return (
      <div
        className={divClass}
        key={meeting.id}
        title={
          time + '  ' + getMeetingTitle(meeting, showMeetingPrivateInfo) + meetingStatus
        }
      >
        <ContextMenuTrigger id={`right_menu_${meeting.id}_${roomId}`}>
          <span className={over ? 'span_over' : ''}>
            <i>{time}</i>
          </span>
          <span className={over ? 'span_over' : ''}>
            <i>
              {
                getMeetingTitle(meeting, showMeetingPrivateInfo)
              }
            </i>
          </span>
        </ContextMenuTrigger>
      </div>
    );
  }
}

MeetingDiv.propTypes = {
  meeting: PropTypes.object.isRequired
};

export default MeetingDiv;



// WEBPACK FOOTER //
// ./src/components/meeting/MeetingDiv.js